export enum AppRoutes {
  Root = '/',
}
